import React, {FC} from 'react'
import Close from '@pixel/assets/icons/Close'
import Dialog from '@pixel/core/Dialog'
import IconButton from '@pixel/core/IconButton'
import { styled, useMediaQuery } from '@pixel/core/styles'
import LocalizedTypography from '../../components/LocalizedTypography'
import { LocalizedText } from '../../contexts/Localization/LocalizationTypes'
import AutomationFormContainer from './AutomationFormContainer'
import useAutomationUpdateQuery from "../hooks/useAutomationUpdateQuery";

const WrappedDialogTitle = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
}))

const FlexCenterDiv = styled('div')({
    display: 'flex',
    alignItems: 'center',
})

interface AutomationFormModalProps {
    open: boolean
    selectedAutomationId: number
    onClose: () => void
    fetchData: () => void
}

export const AutomationFormModal: FC<AutomationFormModalProps> = ({
    open,
    selectedAutomationId,
    onClose,
    fetchData,
}) => {

    const matches = useMediaQuery('(max-width:700px)')

    const {
        data,
    } = useAutomationUpdateQuery({companyAutomationId: selectedAutomationId});


    return (
        <Dialog
            id='automation-form'
            open={open}
            onClose={onClose}
            fullScreen={matches}
            sx={{
                position: 'absolute',
                right: 0,
                left: 'unset',
                minWidth: matches ? '100vw' : 700,
            }}
            scroll="paper"
            PaperProps={{
                sx: { margin: 0, height: '100%', width: '100%', maxHeight: 'unset', maxWidth: 'unset' }
            }}
        >
            <WrappedDialogTitle>
                <LocalizedTypography variant="h1" text={ data?.companyAutomationId
                    ? LocalizedText.AUTOMATION_EDIT_TITLE : LocalizedText.AUTOMATION_FORM_TITLE } />
                <FlexCenterDiv>
                    <IconButton aria-label="Close Modal" onClick={onClose}>
                        <Close />
                    </IconButton>
                </FlexCenterDiv>
            </WrappedDialogTitle>
            <AutomationFormContainer selectedAutomation={data} onModalClose={onClose} fetchData={fetchData} />
        </Dialog>
    )
}

export default AutomationFormModal
